<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: Filters.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,   -->
<!-- propagated, or distributed without prior approval by ESA.               -->
<template>
  <div class="saved-filters container">
    <!-- <h4 v-if="filters.length">My Filters</h4> -->
    <!-- <div
      v-if="warningMessage != ''"
      id="warning-message"
      class="alert alert-warning row"
      role="alert"
    >{{ warningMessage }}</div>-->
    <div
      v-if="warningMessage != ''"
      class="col-cards col-sm-6 col-lg-3 col-xl-3 col-xxl-2 d-flex justify-content-center"
    >
      <div
        v-if="warningMessage != ''"
        id="warning-message"
        class="alert alert-primary card"
        role="alert"
      >
        {{ warningMessage }}
      </div>
    </div>
    <div class="saved-filters__section row">
      <div
        v-for="(filter, idx) in filters"
        :key="idx"
        class="col-cards col-sm-6 col-lg-4 col-xl-3 col-xxl-2 d-flex justify-content-center"
      >
        <div class="saved-filters__item card theme-shadow">
          <div class="card-figure">
            <img
              :src="wpData.image_path + 'filter.png'"
              alt="Card image cap"
              class="card-img-top"
            />
          </div>
          <div class="card-body">
            <div class="card-body-content">
              <p class="card-title">
                <strong>Filter:&nbsp;</strong>
                <router-link class="name" :to="filter.routerLink">{{ filter.name }}</router-link>
              </p>
              <p class="card-description">{{ filter.description }}</p>
            </div>
            <div class="card-buttons">
              <!-- Edit Button -->
              <button
                class="saved-filters__edit card-body-button btn btn-reset"
                title="Edit"
                @click.prevent="openEditFilterModal(filter)"
              >
                <i class="icon icon-edit"></i>
              </button>
              <!-- Delete Button -->
              <button
                class="saved-filters__delete card-body-button btn btn-reset"
                title="Delete"
                @click.prevent="confirmFilterDeletion(filter)"
              >
                <i class="icon icon-delete"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="saved-filters__list">
      <div
        class="saved-filters__filter border-top border-bottom p-1"
        v-for="(filter, idx) in filters"
        :key="idx"
      >
        <div class="row">
          <div class="col-9">
            <strong>Name:&nbsp;</strong>
            <router-link :to="filter.routerLink">{{ filter.name }}</router-link>
            <br />
            <strong>Description:&nbsp;</strong>
            <span>{{ filter.description }}</span>
          </div>
          <div class="col-3">
            <button
              type="button"
              class="saved-filters__delete btn btn-reset float-right"
              @click.prevent="confirmFilterDeletion(filter)"
            >
              <i class="material-icons font-36 text-primary md-interactive"
                >delete_outline</i
              >
            </button>
            <button
              type="button"
              class="saved-filters__edit btn btn-reset float-right"
              @click.prevent="openEditFilterModal(filter)"
            >
              <i
                class="material-icons-outlined font-36 text-primary md-interactive"
                >edit</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>-->
    <!-- edit filter modal -->
    <save-filter-modal
      class="saved-filters__edit-filter-modal"
      v-if="showEditModal"
      :query="currentEditFilter.routerLink.query"
      :id="parseInt(currentEditFilter.filter_id)"
      :initName="currentEditFilter.name"
      :initDesc="currentEditFilter.description"
      @filter-saved="getFilters"
      @closeEditModal="showEditModal = false"
    />
    <message-modal
      v-if="showDeleteModal"
      class="message-modal"
      :title="modalTitle"
      :message="modalMessage"
      :cancel="true"
      :okButtonText="'Delete'"
      @confirmed="deleteFilter"
      @closeMessageModal="showDeleteModal = false"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import SaveFilterModal from '@/components/SaveFilterModal.vue';
import MessageModal from '@/components/MessageModal.vue';
import * as api from '@/lib/api';
import helpers from '@/lib/helpers';

export default {
  name: 'filters',
  components: {
    SaveFilterModal,
    MessageModal,
  },
  data() {
    return {
      filters: [],
      // Currently edited query
      currentEditFilter: null,
      showEditModal: false,
      warningMessage: '',
      //Confirm delete modal
      modalTitle: '',
      modalMessage: '',
      selectedFilterForDelete: null,
      showDeleteModal: false,
      // wpData,
    };
  },
  props: {
    wpData: {
      type: Object,
    },
  },
  computed: {},
  methods: {
    openEditFilterModal(filter) {
      // First set the currently edited filter data
      this.currentEditFilter = filter;
      this.showEditModal = true;
      // Open modal on next DOM update
      Vue.nextTick(() => {
        $('.saved-filters__edit-filter-modal').modal('show');
      });
    },
    confirmFilterDeletion(filter) {
      this.selectedFilterForDelete = filter;
      this.modalTitle = 'Confirm Delete';
      this.modalMessage = `Delete filter "${filter.name}"?`;
      this.showDeleteModal = true;
      Vue.nextTick(() => {
        $('.message-modal').modal('show');
      });
    },
    async deleteFilter() {
      await api.deleteFilter(this.selectedFilterForDelete.filter_id);
      // reload filters
      this.selectedFilterForDelete = null;
      this.getFilters();
    },
    async getFilters() {
      // sort by most recently created filter first
      const response = await api.getSavedFilters({
        /*        sort_by: 'id',
                     order_by: 'desc',
                     // TODO: pagination
                     size: 1000, */
      });
      // List of {name, description, filter-list}
      if (response) this.$emit('finishLoading');
      if (response.results) {
        this.filters = response.results.map(function(row) {
          let query = {};
          let search = row['filter-list'].search;
          // search is array of objects
          // need to convert back to object, and make array out of duplicated (filter) entries
          if (search && search !== 'None') {
            query = helpers.objectFromArrayOfObjectsHandleDuplicates(search);
            //Need to add mode for the frontend to interpret correctly the filter to apply
            // query.mode = query.coord ? 'map' : 'query';
            query.mode = 'map';
          }
          // Add router link params
          return {
            ...row,
            routerLink: {
              name: 'assets',
              query: { vuePage: '1', ...query },
            },
          };
        });
        console.log('FILTERS', this.filters);
        // TODO: pagination
      } else {
        this.filters = [];
        this.warningMessage = response;
      }
    },
  },
  async mounted() {
    await this.getFilters();
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/globals';

//Pequeño ajuste de card, diferente a labs
.card {
  .card-figure {
    .card-img-top {
      // width: 80%;
    }
  }
}

.saved-filters__list {
  background-color: #fff;
}
</style>
